import { DeviceType } from "interfaces"
import { TargetDevice } from "providers/venue/types"

export const canShowOnDevice = (
  targetDevice: TargetDevice,
  deviceType: DeviceType
): boolean => {
  if (targetDevice === "all") return true

  switch (`${targetDevice}-${deviceType}`) {
    case "mobile-mobile":
    case "all_kiosk-kiosk-v":
    case "all_kiosk-kiosk-h":
    case "kiosk_v-kiosk-v":
    case "kiosk_h-kiosk-h":
      return true
    default:
      return false
  }
}
